// extracted by mini-css-extract-plugin
module.exports = {"latest-list":"styles-m__latest-list__rtNIF","section-list":"styles-m__section-list__2bvKO","li-list":"styles-m__li-list__MiVcv","button":"styles-m__button__wHh-C"};